/* src/app/pages/ortho/enviar-caso/enviar-caso.component.scss */
/*# sourceMappingURL=enviar-caso.component.css.map */
